<div class="login__container">
  <div class="login_panel">
    <span class="logo">
      <img src="../../../../assets/images/App-Logo.svg" alt="" />
    </span>


    <div class="form_sub_header">Set New Password</div>

    <form [formGroup]="setNewPassword">

      <div class="row">
        <div class="col-md-12 no-padding">
          <div class="form-group">
            <span class="has-float-label">
              <input
                class="form-control"
                id="newPassword"
                type="password"
                password
                placeholder=" "
                formControlName="newPassword"
                maxlength="8"
                />
              <label for="newPassword">New Password</label>
            </span>
            @if (!showPassword) {
              <i class="fa fa-eye toggle_password" aria-hidden="true" (click)="toggleShowPassword()"></i>
            }
            @if (showPassword) {
              <i class="fa fa-eye-slash toggle_password" aria-hidden="true" (click)="toggleShowPassword()"></i>
            }
            @if (
              setNewPassword.get('newPassword').errors &&
              (setNewPassword.get('newPassword').dirty ||
              setNewPassword.get('newPassword').touched)
              ) {
              <div
                class="validation-message"
                >
                <span
                  class="validation-message"
                [hidden]="
                  !setNewPassword.get('newPassword').hasError('required')
                "
                  >
                  {{ validationMessage.password.required }}
                  <br />
                </span>
                <span
                  class="validation-message"
                [hidden]="
                  !setNewPassword.get('newPassword').hasError('minLength')
                  && !setNewPassword.get('newPassword').dirty
                "
                  >
                  {{ validationMessage.password.minLength }}
                  <br />
                </span>
              </div>
            }
          </div>
        </div>
        <div class="col-md-12 no-padding">
          <div class="form-group">
            <span class="has-float-label">
              <input
                class="form-control"
                id="verifyPassword"
                type="password"
                pattern="{{ setNewPassword.get('newPassword').value }}"
                placeholder=" "
                formControlName="verifyPassword"
                maxlength="8"
                />
              <label for="verifyPassword">Confirm New Password</label>
            </span>
            @if (
              setNewPassword.get('verifyPassword').errors &&
              (setNewPassword.get('verifyPassword').dirty ||
              setNewPassword.get('verifyPassword').touched)
              ) {
              <div
                class="validation-message"
                >
                @if (setNewPassword.get('verifyPassword').errors.pattern) {
                  <span
                    class="validation-message"
                    >Passwords do not match<br
                  /></span>
                }
                <span
                  class="validation-message"
                [hidden]="
                  !setNewPassword.get('verifyPassword').hasError('required')
                "
                  >
                  {{ validationMessage.password.required }}
                  <br />
                </span>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- <div class="bottom_text">
      <a [routerLink]="['../sign-in']">
        Return to Sign In
      </a>
    </div> -->
    @if (!isLoading) {
      <button
        class="form_button"
        [disabled]="!setNewPassword.valid"
        (click)="setPassword()"
        >
        <span>Set New Password and Log In</span>
      </button>
    }
    @if (isLoading) {
      <div class="sbl-circ-path text-center"></div>
    }
  </form>
</div>
</div>
